import {
  CONVERT_TO_EVERGREEN_LEAD,
  CONVERT_TO_EVERGREEN_LEAD_FAILURE,
  CONVERT_TO_EVERGREEN_LEAD_SUCCESS,
  CREATE_ACTIVITY,
  CREATE_ACTIVITY_FAILURE,
  CREATE_ACTIVITY_SUCCESS,
  CREATE_EVERGREEN_LEAD,
  CREATE_EVERGREEN_LEAD_FAILURE,
  CREATE_EVERGREEN_LEAD_SUCCESS,
  GET_ACTIVITIES,
  GET_ACTIVITIES_FAILURE,
  GET_ACTIVITIES_SUCCESS,
  GET_DUPLICATE,
  GET_DUPLICATE_FAILURE,
  GET_DUPLICATE_SUCCESS,
  GET_EVERGREEN_LEAD,
  GET_EVERGREEN_LEADS,
  GET_EVERGREEN_LEADS_FAILURE,
  GET_EVERGREEN_LEADS_SUCCESS,
  GET_EVERGREEN_LEADS_SUGGESTION_FAILURE,
  GET_EVERGREEN_LEADS_SUGGESTION_SUCCESS,
  GET_EVERGREEN_LEAD_FAILURE,
  GET_EVERGREEN_LEAD_SUCCESS,
  GET_LOG,
  GET_LOG_FAILURE,
  GET_LOG_SUCCESS,
  IMPORT_EVERGREEN_LEADS,
  IMPORT_EVERGREEN_LEADS_FAILURE,
  IMPORT_EVERGREEN_LEADS_SUCCESS,
  EvergreenLeadsDispatchTypes,
  EvergreenLeadsType,
  EVERGREEN_LEAD_ASSIGN,
  EVERGREEN_LEAD_ASSIGN_FAILURE,
  EVERGREEN_LEAD_ASSIGN_SUCCESS,
  UPDATE_ACTIVITY,
  UPDATE_ACTIVITY_FAILURE,
  UPDATE_ACTIVITY_SUCCESS,
  UPDATE_FILTER_EVERGREEN_LEADS,
  UPDATE_EVERGREEN_LEAD,
  UPDATE_EVERGREEN_LEAD_FAILURE,
  UPDATE_EVERGREEN_LEAD_SUCCESS,
} from './evergreen-leads-types';

interface DefaultStateI {
  loading: boolean;
  error?: boolean;
  messages?: any;

  evergreenLeads: EvergreenLeadsType;

  loadingGetEvergreenLead: boolean;
  successGetEvergreenLead: boolean;
  errorGetEvergreenLead: boolean;
  evergreenLead?: any;
  errorMessage: {};

  loadingUpdateEvergreenLead: boolean;
  successUpdateEvergreenLead: boolean;
  errorUpdateEvergreenLead: boolean;

  filterQuery: any;

  loadingGetDuplicate: boolean;
  successGetDuplicate: boolean;
  errorGetDuplicate: boolean;
  duplicate?: any;
  errorMessageDuplicate: {};

  loadingGetActivities: boolean;
  successGetActivities: boolean;
  errorGetActivities: boolean;
  activities?: any;
  errorMessageActivities: {};

  loadingCreateActivity: boolean;
  successCreateActivity: boolean;
  errorCreateActivity: boolean;

  loadingUpdateActivity: boolean;
  successUpdateActivity: boolean;
  errorUpdateActivity: boolean;

  loadingCreateEvergreenLead: boolean;
  successCreateEvergreenLead: boolean;
  errorCreateEvergreenLead: boolean;

  evergreenLeadsSuggestions?: any;

  loadingGetLogs: boolean;
  successGetLogs: boolean;
  errorGetLogs: boolean;
  logs?: any;
  errorMessageLog: {};

  loadingConvertToEvergreenLead: boolean;
  successConvertToEvergreenLead: boolean;
  errorConvertToEvergreenLead: boolean;

  loadingEvergreenLeadAssigns: boolean;
  successEvergreenLeadAssigns: boolean;
  errorEvergreenLeadAssigns: boolean;

  loadingImportEvergreenLeads: boolean;
  successImportEvergreenLeads: boolean;
  errorImportEvergreenLeads: boolean;
}

const defaultState: DefaultStateI = {
  loading: false,
  evergreenLeads: {
    data: [],
  },

  loadingGetEvergreenLead: false,
  successGetEvergreenLead: false,
  errorGetEvergreenLead: false,
  evergreenLead: {},
  errorMessage: {},

  loadingUpdateEvergreenLead: false,
  successUpdateEvergreenLead: false,
  errorUpdateEvergreenLead: false,

  filterQuery: {},

  loadingGetDuplicate: false,
  successGetDuplicate: false,
  errorGetDuplicate: false,
  duplicate: {},
  errorMessageDuplicate: {},

  loadingGetActivities: false,
  successGetActivities: false,
  errorGetActivities: false,
  activities: {},
  errorMessageActivities: {},

  loadingCreateActivity: false,
  successCreateActivity: false,
  errorCreateActivity: false,

  loadingUpdateActivity: false,
  successUpdateActivity: false,
  errorUpdateActivity: false,

  loadingCreateEvergreenLead: false,
  successCreateEvergreenLead: false,
  errorCreateEvergreenLead: false,

  loadingGetLogs: false,
  successGetLogs: false,
  errorGetLogs: false,
  logs: {},
  errorMessageLog: {},

  loadingConvertToEvergreenLead: false,
  successConvertToEvergreenLead: false,
  errorConvertToEvergreenLead: false,

  loadingEvergreenLeadAssigns: false,
  successEvergreenLeadAssigns: false,
  errorEvergreenLeadAssigns: false,

  loadingImportEvergreenLeads: false,
  successImportEvergreenLeads: false,
  errorImportEvergreenLeads: false,
};

const evergreenLeadsReducer = (state: DefaultStateI = defaultState, action: EvergreenLeadsDispatchTypes): DefaultStateI => {
  switch (action.type) {
    case GET_EVERGREEN_LEADS:
      return {
        ...state,
        loading: true,
      };
    case GET_EVERGREEN_LEADS_SUCCESS:
      return {
        ...state,
        loading: false,
        evergreenLeads: action.payload,
      };
    case GET_EVERGREEN_LEADS_FAILURE:
      return {
        ...state,
        loading: false,
        messages: action.message,
      };
    case GET_EVERGREEN_LEAD:
      return {
        ...state,
        loadingGetEvergreenLead: true,
        successGetEvergreenLead: false,
        errorGetEvergreenLead: false,
      };
    case GET_EVERGREEN_LEAD_SUCCESS:
      return {
        ...state,
        loadingGetEvergreenLead: false,
        successGetEvergreenLead: true,
        errorGetEvergreenLead: false,
        evergreenLead: action.payload,
      };
    case GET_EVERGREEN_LEAD_FAILURE:
      return {
        ...state,
        loadingGetEvergreenLead: false,
        successGetEvergreenLead: false,
        errorGetEvergreenLead: true,
        errorMessage: action.message,
      };
    case UPDATE_EVERGREEN_LEAD:
      return {
        ...state,
        loadingUpdateEvergreenLead: true,
        successUpdateEvergreenLead: false,
        errorUpdateEvergreenLead: false,
      };
    case UPDATE_EVERGREEN_LEAD_SUCCESS:
      return {
        ...state,
        loadingUpdateEvergreenLead: false,
        successUpdateEvergreenLead: true,
        errorUpdateEvergreenLead: false,
      };
    case UPDATE_EVERGREEN_LEAD_FAILURE:
      return {
        ...state,
        loadingUpdateEvergreenLead: false,
        successUpdateEvergreenLead: false,
        errorUpdateEvergreenLead: true,
        errorMessage: action.message,
      };
    case GET_DUPLICATE:
      return {
        ...state,
        loadingGetDuplicate: true,
        successGetDuplicate: false,
        errorGetDuplicate: false,
      };
    case GET_DUPLICATE_SUCCESS:
      return {
        ...state,
        loadingGetDuplicate: false,
        successGetDuplicate: true,
        errorGetDuplicate: false,
        duplicate: action.payload,
      };
    case GET_DUPLICATE_FAILURE:
      return {
        ...state,
        loadingGetActivities: false,
        successGetActivities: false,
        errorGetActivities: true,
        errorMessageDuplicate: action.message,
      };
    case GET_ACTIVITIES:
      return {
        ...state,
        loadingGetActivities: true,
        successGetActivities: false,
        errorGetActivities: false,
      };
    case GET_ACTIVITIES_SUCCESS:
      return {
        ...state,
        loadingGetActivities: false,
        successGetActivities: true,
        errorGetActivities: false,
        activities: action.payload,
      };
    case GET_ACTIVITIES_FAILURE:
      return {
        ...state,
        loadingGetActivities: false,
        successGetActivities: false,
        errorGetActivities: true,
        errorMessageActivities: action.message,
      };
    case UPDATE_FILTER_EVERGREEN_LEADS:
      return {
        ...state,
        filterQuery: action.payload,
      };
    case CREATE_ACTIVITY:
      return {
        ...state,
        loadingCreateActivity: true,
        successCreateActivity: false,
        errorCreateActivity: false,
      };
    case CREATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingCreateActivity: false,
        successCreateActivity: true,
        errorCreateActivity: false,
      };
    case CREATE_ACTIVITY_FAILURE:
      return {
        ...state,
        loadingCreateActivity: false,
        successCreateActivity: false,
        errorCreateActivity: true,
        errorMessage: action.message,
      };
    case UPDATE_ACTIVITY:
      return {
        ...state,
        loadingUpdateActivity: true,
        successUpdateActivity: false,
        errorUpdateActivity: false,
      };
    case UPDATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingUpdateActivity: false,
        successUpdateActivity: true,
        errorUpdateActivity: false,
      };
    case UPDATE_ACTIVITY_FAILURE:
      return {
        ...state,
        loadingUpdateActivity: false,
        successUpdateActivity: false,
        errorUpdateEvergreenLead: true,
        errorMessage: action.message,
      };
    case CREATE_EVERGREEN_LEAD:
      return {
        ...state,
        loadingCreateEvergreenLead: true,
        successCreateEvergreenLead: false,
        errorCreateEvergreenLead: false,
      };
    case CREATE_EVERGREEN_LEAD_SUCCESS:
      return {
        ...state,
        loadingCreateEvergreenLead: false,
        successCreateEvergreenLead: true,
        errorCreateEvergreenLead: false,
        evergreenLead: action.payload,
      };
    case CREATE_EVERGREEN_LEAD_FAILURE:
      return {
        ...state,
        loadingCreateEvergreenLead: false,
        successCreateEvergreenLead: false,
        errorCreateEvergreenLead: true,
        errorMessage: action.message,
      };
    case GET_EVERGREEN_LEADS_SUGGESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        evergreenLeadsSuggestions: action.payload,
      };
    case GET_LOG:
      return {
        ...state,
        loadingGetLogs: true,
        successGetLogs: false,
        errorGetLogs: false,
      };
    case GET_LOG_SUCCESS:
      return {
        ...state,
        loadingGetLogs: false,
        successGetLogs: true,
        errorGetLogs: false,
        logs: action.payload,
      };
    case GET_LOG_FAILURE:
      return {
        ...state,
        loadingGetLogs: false,
        successGetLogs: false,
        errorGetLogs: true,
        errorMessageLog: action.message,
      };
    case GET_EVERGREEN_LEADS_SUGGESTION_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case CONVERT_TO_EVERGREEN_LEAD:
      return {
        ...state,
        loadingConvertToEvergreenLead: true,
        successConvertToEvergreenLead: false,
        errorConvertToEvergreenLead: false,
      };
    case CONVERT_TO_EVERGREEN_LEAD_SUCCESS:
      return {
        ...state,
        loadingConvertToEvergreenLead: false,
        successConvertToEvergreenLead: true,
        errorConvertToEvergreenLead: false,
      };
    case CONVERT_TO_EVERGREEN_LEAD_FAILURE:
      return {
        ...state,
        loadingConvertToEvergreenLead: false,
        successConvertToEvergreenLead: false,
        errorConvertToEvergreenLead: true,
        errorMessage: action.message,
      };
    case EVERGREEN_LEAD_ASSIGN:
      return {
        ...state,
        loadingEvergreenLeadAssigns: true,
        successEvergreenLeadAssigns: false,
        errorEvergreenLeadAssigns: false,
      };
    case EVERGREEN_LEAD_ASSIGN_SUCCESS:
      return {
        ...state,
        loadingEvergreenLeadAssigns: false,
        successEvergreenLeadAssigns: true,
        errorEvergreenLeadAssigns: false,
      };
    case EVERGREEN_LEAD_ASSIGN_FAILURE:
      return {
        ...state,
        loadingEvergreenLeadAssigns: false,
        successEvergreenLeadAssigns: false,
        errorEvergreenLeadAssigns: true,
        errorMessage: action.message,
      };
    case IMPORT_EVERGREEN_LEADS:
      return {
        ...state,
        loadingImportEvergreenLeads: true,
        successImportEvergreenLeads: false,
        errorImportEvergreenLeads: false,
      };
    case IMPORT_EVERGREEN_LEADS_SUCCESS:
      return {
        ...state,
        loadingImportEvergreenLeads: false,
        successImportEvergreenLeads: true,
        errorImportEvergreenLeads: false,
      };
    case IMPORT_EVERGREEN_LEADS_FAILURE:
      return {
        ...state,
        loadingImportEvergreenLeads: false,
        successImportEvergreenLeads: false,
        errorImportEvergreenLeads: true,
        errorMessage: action.message,
      };
    default:
      return state;
  }
};

export default evergreenLeadsReducer;
